export default __webpack_public_path__ + "static/media/ico-drop-droite-black.27bcce41.svg";